// extracted by mini-css-extract-plugin
export var auto = "_2x-1";
export var spinner = "_2x-0";